import React from 'react';

const PaletteIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M21.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-3-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M16 7a9 9 0 1 0 0 18 1.5 1.5 0 0 0 1.5-1.5c0-.39-.15-.74-.39-1-.23-.27-.38-.62-.38-1a1.5 1.5 0 0 1 1.5-1.5H20a5 5 0 0 0 5-5c0-4.42-4.03-8-9-8z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default PaletteIcon;
